import {
  useApplyCouponHandler,
  useCartAndDeliveryDatesDataContext,
  useGetAssignedCoupons,
  useRemoveCouponHandler,
} from '@app/data/clients/cartCheckoutClient';
import { StateCode } from '@app/data/clients/cartCheckoutClient/CartAndDeliveryDatesDataContext/hooks/AsyncHookState';
import { useEffect } from 'react';
import { ApplyCoupon, ApplyCouponProps } from './ApplyCoupon';

export type MonolithApplyCouponContainerProps = {} & Pick<
  ApplyCouponProps,
  'shippingAddress'
>;

export const MonolithApplyCouponContainer = ({
  shippingAddress,
}: MonolithApplyCouponContainerProps) => {
  const { client, dispatch, cart } = useCartAndDeliveryDatesDataContext();

  const {
    data: assignedCouponsData,
    handler: fetchAssignedCoupons,
    state: fetchAssignedCouponsState,
  } = useGetAssignedCoupons({ client, dispatch });

  const { handler: doCouponCodeApply, isLoading: isApplyingCoupon } =
    useApplyCouponHandler(client, dispatch);

  const { handler: doCouponCodeRemove, isLoading: isRemovingCoupon } =
    useRemoveCouponHandler(client, dispatch);

  const assignedCoupons = assignedCouponsData?.assigned_coupons;

  const appliedCoupon = cart?.applied_coupon || undefined;

  const isLoadingApplyCoupon =
    !fetchAssignedCouponsState ||
    fetchAssignedCouponsState === StateCode.LOADING;

  useEffect(() => {
    if (!fetchAssignedCouponsState && cart) {
      fetchAssignedCoupons();
    }
  }, [cart, fetchAssignedCoupons, fetchAssignedCouponsState]);

  return (
    <ApplyCoupon
      assignedCoupons={assignedCoupons}
      appliedCoupon={appliedCoupon}
      isLoading={isLoadingApplyCoupon}
      isLoadingMemberOffers={isApplyingCoupon || isRemovingCoupon}
      hasServerError={fetchAssignedCouponsState === StateCode.FAILED}
      doCouponCodeApply={doCouponCodeApply}
      doCouponCodeRemove={doCouponCodeRemove}
      shippingAddress={shippingAddress}
    />
  );
};
